export default () => "paypal error page";
